<template>
  <div class="detail-charts">
    <div class="chart-panel">
        <transition name="fade">
            <div v-if="loading" class="loading-wrapper">
                <BaseSpinner text="info.loading_data" />
            </div>
        </transition>
      <div class="chart-panel__header" :id="`test-detail-chart-${sensor.name.toLowerCase()}`">
        <div>{{ $t(`metrics.${sensor.name.toLowerCase().replaceAll(" ","_").replace("%","_")}`) }}</div>
          <div class="chart-panel__info__period" @click="toggleChartPeriodSelect2" v-click-outside="hideChartPeriodSelect2" v-responsive.sm.xs.md>
              <div style="display: flex;">
                  <span>{{ selectedPeriod.name }}</span>
                  <BaseIcon icon="chevron-down" />
              </div>
              <transition name="fadeUp">
                  <BaseSelectList
                          v-if="showChartPeriodSelect2"
                          :items="chartPeriodOptions"
                          :active="selectedPeriod"
                          @onSelect="setChartPeriod"
                          style="z-index: 13;"
                  />
              </transition>
          </div>
        <div v-if="false" class="chart-panel__header__settings">
          <BaseIcon icon="settings" @click="toggleChartSettings" />
          <transition name="fadeUp">
            <div v-if="showChartSettings" class="graph-settings"></div>
          </transition>
        </div>
      </div>
      <div class="chart-panel__info" v-responsive.lg.xl.md>
          <div class="chart-panel__info__min" v-if="showMinMax(sensor.name)">
              <span class="description">{{ $t('detail.min_value') }}</span>
              <span class="value">{{ minValue ? minValue.toFixed(2) : 'N/A' }}{{ hasValues && minValue ? sensor.unit : ''}}</span>
          </div>
          <div class="chart-panel__info__actual" v-if="showMinMax(sensor.name)">
              <span class="description">{{ $t('detail.last_value') }}</span>
              <span class="value">{{ lastValue ? lastValue.toFixed(2) : 'N/A' }}{{ hasValues && lastValue ? sensor.unit : ''}}</span>
          </div>
          <div class="chart-panel__info__max" v-if="showMinMax(sensor.name)">
              <span class="description">{{ $t('detail.max_value') }}</span>
              <span class="value">{{ maxValue ? maxValue.toFixed(2) : 'N/A' }}{{hasValues && maxValue ? sensor.unit : ''}}</span>
          </div>
        <div class="chart-panel__info__period test-button-time-range" @click="toggleChartPeriodSelect" v-click-outside="hideChartPeriodSelect" v-responsive.lg.xl>
          <div style="display: flex;">
            {{ $t('detail.select_data') }}:
            <span>{{ computedPeriodOption.name }}</span>
            <BaseIcon icon="chevron-down" />
          </div>
          <transition name="fadeUp">
            <BaseSelectList
              v-if="showChartPeriodSelect"
              :items="chartPeriodOptions"
              :active="computedPeriodOption"
              @onSelect="setChartPeriod"
              style="z-index: 13;"
            />
          </transition>
        </div>
        <div v-if="showCustomDateRange" class="date-range-picker">
          <date-range-picker
              ref="picker"
              :opens="'top'"
              :showControls="true"
              :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
              :singleDatePicker="false"
              @update="setChartcustomPeriod"
              @click="checkOpen"
              :theme="rangePickerTheme"
              :submitTitle="$t('buttons.apply_range')"
              :dateFormat="dateFormat"
          >
          </date-range-picker>
        </div>
      </div>
      <div class="chart-panel__chart">
        <apexchart height="100%" width="100%" :type="getApexType(sensor.name)" :options="chartOptions" :series="series">
        </apexchart>
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
import { chartPeriods } from '@/config/charts';
import { mapGetters } from 'vuex';
import 'vue-mj-daterangepicker/dist/vue-mj-daterangepicker.css';

export default {
  name: 'DetailChartPanel',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    sensor: {
      type: Object,
      required: true,
    },
    unit: {
      type: Object,
      required: true,
    },
    loadedData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  created() {
    // this.setChartData(this.getDateFromToday(-1, 0, 0), this.getDateFromToday(0, 0, 0));
    // this.transformData(this.loadedData);
    this.showCustomDateRange = false;
    if (!this.sensor.id) {
      this.loading = false;
    }
  },
  data() {
    return {
      // START CHART OPTION
      loading: true,
      series: [
        {
          name: 'Temperature',
          data: [],
        },
      ],
      // END CHART OPTIONS
      showChartSettings: false,
      showChartPeriodSelect: false,
      showChartPeriodSelect2: false,
      selectedPeriod: { id: 4, value: 'day' , name: this.$t('interval.day') },
    };
  },
  computed: {
    ...mapGetters('tentacle', ['timeFormat']),
    computedPeriodOption() {
      const option = this.selectedPeriod;
      option.name = this.$t(`interval.${option.value}`);
      return option;
    },
    getCriticalColors() {
      const range = this.maxValue - this.minValue;
      const coef = 0.125;
      const retVal = [];
      if (this.sensor.minCrit >= this.minValue - coef * range
            && this.sensor.minCrit <= this.maxValue + coef * range) {
        retVal.push('#6fbdea');
      } else {
        retVal.push('rgba(0,0,0,0)');
      }
      if (this.sensor.maxCrit >= this.minValue - coef * range
            && this.sensor.maxCrit <= this.maxValue + coef * range) {
        retVal.push('#ff5a5a');
      } else {
        retVal.push('rgba(0,0,0,0)');
      }
      return retVal;
    },
    chartOptions() {
      return {
        chart: {
          toolbar: {
            show: true,
          },
        },
        colors: ['#b2de4d', '#64b5f6', '#ffb74d', '#f47f7f',
              '#a1887f', '#7da453', '#2286c3', '#c75b39',
              '#af4448', '#725b53'],
        stroke: {
          curve: 'straight',
        },
        annotations: {
          show: true,
          yaxis: [{
            y: this.sensor.minCrit,
            strokeDashArray: 5,
            borderColor: this.getCriticalColors[0],
            label: {
              borderColor: '#6fbdea',
              style: {
                color: '#fff',
                background: '#6fbdea',
                fontSize: '1.5em',
              },
              text: '',
            },
          },
          {
            y: this.sensor.maxCrit,
            strokeDashArray: 5,
            borderColor: this.getCriticalColors[1],
            label: {
              borderColor: '#ff5a5a',
              style: {
                color: '#fff',
                background: '#ff5a5a',
                fontSize: '1.5em',
              },
              text: '',
            },
          }],
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          fontSize: '14px',
          fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
          offsetY: -10,
          labels: {
            colors: '#acb4c5',
          },
          itemMargin: {
            horizontal: 10,
            vertical: 10,
          },
        },
        dataLabels: {
          enabled: false,
          formatter: (val, opts) => `${val} ${this.sensor.unit}`,
          textAnchor: 'middle',
          style: {
            fontSize: '12px',
            fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
          },
        },
        fill: {
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
        grid: {
          show: true,
          borderColor: '#eee',
          strokeDashArray: 5,
          position: 'back',
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        noData: {
          text: this.$t('detail.missing'),
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
          },
        },
        tooltip: {
          enabled: true,
          style: {
            fontSize: '12px',
            fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
          },
          x: {
            formatter: (val, opts) => {
              if (typeof opts.series !== 'undefined'){
                  if (opts.series[opts.seriesIndex][opts.dataPointIndex] === null){
                      return null;
                  }
              }
              const newDate = new Date(val);
              const utcDate = new Date(newDate.getUTCFullYear(),newDate.getUTCMonth(),newDate.getUTCDate(),newDate.getUTCHours(),newDate.getUTCMinutes(),newDate.getUTCSeconds());
              const outDate = this.moment(utcDate).format(this.timeFormat ? 'DD MMM YYYY, hh:mm a' : 'DD MMM YYYY, HH:mm');
              return `${outDate}`;
            },
          },
          y: {
            formatter: (val, opts) => {
                return val !== null ? `${val} ${this.sensor.unit}` : null;
            },
          },
          z: {
            title: 'Raw: ',
          },
          marker: {
            show: true,
          },
        },
        yaxis: {
          decimalsInFloat: 2,
          labels: {
            show: true,
            style: {
              color: '#acb4c5',
              fontSize: '12px',
              fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
            },
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            // format: 'dd MMM yyyy',
            style: {
              colors: '#acb4c5',
              fontSize: '12px',
              fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
            },
          },
        },
      };
    },
    chartPeriodOptions() {
      chartPeriods.forEach(item => item.name = this.$t(`interval.${item.value}`));
      return chartPeriods;
    },
    hasValues() {
      return this.series.length > 0 && this.series[0].data.length > 0;
    },
    minValue() {
      if (this.hasValues) {
        return this.series[0].data.reduce((total, current) => {
          if (current[1] < total) {
            total = current[1];
          }
          return Number(total);
        }, this.series[0].data[0][1]);
      }
      return NaN;
    },
    lastValue() {
      const { data } = this.series[0];
      return this.hasValues ? Number(data[data.length - 1][1]) : NaN;
    },
    maxValue() {
      if (this.hasValues) {
        return this.series[0].data.reduce((total, current) => {
          if (current[1] > total) {
            total = current[1];
          }
          return Number(total);
        }, this.series[0].data[0][1]);
      }
      return NaN;
    },
  },
  watch: {
    loadedData(newVal, oldVal) {
      this.updateData(this.unit.typeId, newVal);
    },
  },
  methods: {
    getApexType(sensorName) {
        switch (sensorName) {
            case 'Events':
                return 'scatter';
            case 'Angles':
                return 'line';
            case 'Currents':
                return 'line';
            default:
                return 'line';
        }
    },
    showMinMax(sensorName) {
       return sensorName !== 'Events';
    },
    getIntervalOption(value) {
      return this.chartPeriodOptions.find(item => item.value === value);
    },
    updateData(typeId, newData) {
      const filtered = this.sensor.id.length > 1 ? newData.filter(item => this.sensor.id.includes(item.id)) : newData.filter(item => this.sensor.id === item.id);
      if (filtered.length > 0) {
        this.loading = true;
        const series = [];
        filtered.forEach((data) => {
              if (data.id) {
                  let name = typeId === 16 ? this.$t(`metrics.${data.name.toLowerCase()}`) : this.$t(`metrics.${this.sensor.name.toLowerCase()}`);
                  const sensor = {
                      name: name,
                      data: [],
                  };

                  let chartData = [];
                  if (data.values.length > 0) {
                    chartData = data.values;
                    for (let i = 1; i < chartData.length; i++) {
                      if (chartData[i].timestamp - chartData[i - 1].timestamp > (4.5 * 60 * 60)) {
                        const item = {
                          value: null,
                          rawValue: null,
                          timestamp: (parseInt(chartData[i].timestamp) + parseInt(chartData[i - 1].timestamp)) / 2,
                        };
                        chartData.splice(i, 0, item);
                      }
                    }
                  }

                  sensor.data = chartData.reduce((total, current) => {
                      let checkedRawValue = current.rawValue === null ? '-' : current.rawValue;
                      let date = new Date(Number(current.timestamp) * 1000);
                      date.setHours(date.getHours() + 2);
                      total.push([date.getTime(), current.value, checkedRawValue]);
                      return total;
                  }, []);
                  series.push(sensor);
              }
          });
        this.series = series;
      }
      this.loading = false;
    },
	  calcDateFromToday(year, month, day) {
		  let cDate = new Date().getDate() + day;
		  let cMonth = new Date().getMonth() + 1 + month;
		  let cYear = new Date().getFullYear() + year;

		  if(!this.isJanuary() && cDate < 1){
		      let daysTotal = new Date(cYear, --cMonth, 0).getDate();
              cDate = daysTotal + cDate;
          }
		  //checks if day goes into december and counts back days
		  if (this.isJanuary() && cDate < 1) {
			  cDate = 31 + cDate;
			  cMonth = 12;
			  cYear = cYear - 1;
		  }
		  //checks if month goes back to previous year and counts from 12
		  if (this.isPreviousYearMonth(month)) {
			  cMonth = 12 + cMonth;
			  cYear = cYear - 1;
		  }
		  return `${cYear}-${cMonth}-${cDate}`;
	  },
	  getDateFromToday() {
		  return `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`;
	  },
	  isJanuary(){
		  return (new Date().getMonth() + 1) == 1;
	  },
	  isPreviousYearMonth(month){
		  return ((new Date().getMonth() + 1 + month) <= 0 ) ;
	  },
    setChartData(fromDate, toDate) {
      this.loading = true;
      const filter = [{ id: this.sensor.id, from: fromDate, to: toDate }];
        const data = {tentacle: this.unit.id, filter: filter};
      this.$store.dispatch('tentacle/setMeasurement', data).then((resolve) => {
        let chartData = [];
        if (resolve.data) {
          chartData = resolve.data;
        }
        this.updateData(this.unit.typeId, chartData);
      });
    },
    toggleChartSettings() {
      this.showChartSettings = !this.showChartSettings;
    },
    toggleChartPeriodSelect() {
      this.showChartPeriodSelect = !this.showChartPeriodSelect;
    },
    toggleChartPeriodSelect2() {
      this.showChartPeriodSelect2 = !this.showChartPeriodSelect2;
    },
    hideChartPeriodSelect2() {
      this.showChartPeriodSelect2 = false;
    },
    hideChartPeriodSelect() {
      this.showChartPeriodSelect = false;
    },
    setChartcustomPeriod(picker) {
      this.showCustomDateRange = false;
      var dateFrom = new Date(picker.from);
      var dateTo = new Date(picker.to);
      var dateFromString = this.moment(dateFrom).format("YYYY-MM-DD");
      var dateToString = this.moment(dateTo).format("YYYY-MM-DD");

      this.setChartData(dateFromString, dateToString);
    },
    setChartPeriod(item) {

      this.showChartPeriodSelect = !this.showChartPeriodSelect;
      if (item.value === 'year' && this.selectedPeriod.value !== 'year') {
        this.setChartData(this.calcDateFromToday(-1, 0, 0), this.getDateFromToday());
      } else if (item.value === 'month' && this.selectedPeriod.value !== 'month') {
        this.setChartData(this.calcDateFromToday(0, -1, 0), this.getDateFromToday());
      } else if (item.value === 'week' && this.selectedPeriod.value !== 'week') {
        this.setChartData(this.calcDateFromToday(0, 0, -6), this.getDateFromToday());
      } else if (item.value === 'day' && this.selectedPeriod.value !== 'day') {
        this.setChartData(this.calcDateFromToday(0, 0, -1), this.getDateFromToday());
      } else if (item.value === 'customRange') {
        this.showCustomDateRange = true;
      }
      this.selectedPeriod = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-panel {
    position:relative;
  margin-bottom: 4rem;
  border-radius: 2rem;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(100, 116, 160, 0.1);
    @media only screen and (max-width: 1199px) {
        width: 90%;
        margin:auto;
        margin-top: 2em;
    }
    @media only screen and (min-width: 1200px) and (max-width: 1400px) {
        margin-left: 2%;
        width: 94%;
    }

  &__header {
    padding: 0 3rem;
    height: 6rem;
    border-bottom: 0.1rem solid $border-color;
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 1.4rem;
    color: $grey;

    &__settings {
      position: relative;
      margin-left: auto;
      cursor: pointer;
      display: flex;
      align-items: center;

      svg {
        width: 1.8rem;
        height: 1.8rem;
      }

      .icon {
        fill: $grey;
        width: 1.8rem 1.8rem;
      }

      .graph-settings {
        position: absolute;
        z-index: 12;
        top: 3rem;
        right: -1rem;
        padding: 1rem;
        width: 20rem;
        height: 10rem;
        background-color: $white;
        box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15),
          0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);
      }
    }
  }

  &__info {
    padding: 0 3rem;
    display: flex;
    height: 8rem;
    align-items: stretch;

    &__min,
    &__actual,
    &__max {
      min-width: 18rem;
      display: flex;
      height: 100%;
      align-items: center;
      font-size: 3rem;
      font-weight: 700;
      color: $dark;

      .value {
        color: $grey;

        &.max {
          color: $max-color;
        }

        &.min {
          color: $min-color;
        }
      }

      .description {
        font-size: 1.1rem;
        width: 4.6rem;
        display: inline-flex;
        align-items: center;
        height: 3rem;
        text-align: end;
        margin-right: 2rem;
        position: relative;

        &:after {
          content: '';
          display: inline-block;
          position: absolute;
          right: -1rem;
          width: 0.1rem;
          height: 100%;
          background-color: $very-light-grey;
        }
      }
    }

    &__actual {
      .value {
        color: $company-color;
      }
    }

    &__period {
      position: relative;
      display: flex;
      align-items: center;
      margin-left: auto;
      font-weight: 500;
      color: $grey;
      align-self: center;
      padding: 1.5rem;
      border-radius: 0.5rem;
      cursor: pointer;
      font-size: 1.2rem;
      transition: all 0.4s;

      svg {
        width: 1.2rem;
        height: 1.2rem;
      }

      &:hover {
        background-color: $bg;
      }

      span {
        margin-left: 1rem;
        min-width: 7rem;
        color: $dark;
      }
    }
  }

  &__chart {
    padding: 0 3rem;
    min-height: 28rem;
      width: 100%;
      height: 280px;
      @media only screen and (max-width: 991px) {
          padding: 0;
      }
  }

  &__footer {
    height: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 500;
    color: $grey;

    span {
      width: 2rem;
      height: 0.6rem;
      border-radius: 0.2rem;
      background-color: $company-color;
      margin-right: 0.5rem;
    }
  }
}
.loading-wrapper {
    position: absolute;
    border-radius: 2rem;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
}
</style>
<style>
.date-range-picker {
    z-index: 999;
    background-color: #fff;
    right: 30px;
    position: relative;
}
.mj-daterange-picker {
    background-color: #fff;
}
.date-range-picker .mj-daterange-picker-controls .mj-daterange-picker-submit {
    display: inline-flex !important;
}
.chart-panel__info__period span {
    margin-right: 1rem;
}
</style>
